import {getReverseSortGroupPlan} from "../resources/ReverseSortGroupPlanResource";

export const FETCH_REVERSE_SORT_GROUP_PLAN_BEGIN = "FETCH_REVERSE_SORT_GROUP_PLAN_BEGIN";
export const FETCH_REVERSE_SORT_GROUP_PLAN_SUCCESS = "FETCH_REVERSE_SORT_GROUP_PLAN_SUCCESS";
export const FETCH_REVERSE_SORT_GROUP_PLAN_FAILURE = "FETCH_REVERSE_SORT_GROUP_PLAN_FAILURE";

const fetchReverseSortGroupPlanBegin = () => ({
    type: FETCH_REVERSE_SORT_GROUP_PLAN_BEGIN
});

const fetchReverseSortGroupPlanSuccess = (planDay, sortGroupPlans) => ({
    type: FETCH_REVERSE_SORT_GROUP_PLAN_SUCCESS,
    planDay,
    sortGroupPlans
});

const fetchReverseSortGroupPlanFailure = (error) => ({
    type: FETCH_REVERSE_SORT_GROUP_PLAN_FAILURE,
    error
});

/**
 * Thunk action that fetches the reverse sort group plan for a given node.
 * Dispatches begin, then success or failure based on the API response.
 *
 * @param {string} nodeId - The station identifier (e.g., "DIG1")
 */
export const fetchReverseSortGroupPlan = (nodeId) => {
    return async (dispatch) => {
        try {
            dispatch(fetchReverseSortGroupPlanBegin());
            const response = await getReverseSortGroupPlan({nodeId});
            dispatch(fetchReverseSortGroupPlanSuccess(response.planDay, response.sortGroupPlans));
        } catch (error) {
            dispatch(fetchReverseSortGroupPlanFailure(error));
        }
    };
};



// WEBPACK FOOTER //
// ./src/actions/ReverseSortGroupPlanActions.js